import React from 'react';

import {RawHTML} from 'polyphony/components/generic';
import {PostWrapper, PostBody} from 'polyphony/components/frontend';

const Post = ({post=null, excerpted=false}) =>
    <PostWrapper post={post}>
        <a href={post.permalink}><RawHTML tag="h1" className="post-title">{post.title}</RawHTML></a>
        {post.author && <h4>{`${post.author.display_name} | ${post.post_date}`}</h4>}
        {excerpted && <div><RawHTML>{post.excerpt}</RawHTML></div>}
        {post.content.map((x, i) => <PostBody key={i}>{x}</PostBody>)}
    </PostWrapper>;

export default Post;

